<template>
  <div  ref="appView" id="app">
    <router-view />
  </div>
</template>

<script>

export default {
  name: "App",
  mounted() {

  },
  data() {
    return {
    }
  },

};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
#app {
  cursor: pointer;
}
.videp {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60%;
  height: 60%;
  object-fit: fill;
}
.qian {
  width: 60%;
  position: absolute;
  top: 14%;
  text-align: center;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 35px;
  color: #fff;
}
.yindaoru {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  /* background: #06121e;
  opacity: 0.8; */
  z-index: 9999;
  background-image: url("./assets/touming.png");
  background-size: 100% 100%;
}
.yindaosf {
  width: 183px;
  height: 116px;
  position: absolute;
  top: 270px;
  left: 56.5%;
}
.zhiyin {
  width: 44px;
  height: 44px;
  position: absolute;
  top: 390px;
  left: 65%;
}
.dianjis {
  width: 265px;
  height: 47px;
  position: absolute;
  top: 395px;
  left: 68%;
}
.kkkk {
  width: 170px;
  height: 58px;
  background: #fff;
  position: absolute;
  top: 190px;
  left: 45%;
}
</style>
